import { useCallback, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

export const useQueryParams = <T extends Record<string, string> = Record<string, string>>() => {
  const [rawParams, setRawParams] = useSearchParams()

  const params = useMemo(() => Object.fromEntries(rawParams.entries()) as Partial<T>, [rawParams])

  const set = useCallback(
    (key: keyof T & string, value: string | undefined) => {
      setRawParams((prev) => {
        const next = new URLSearchParams(prev)
        if (value) next.set(key, value)
        else next.delete(key)
        return next
      })
    },
    [setRawParams],
  )

  return { params, setParam: set }
}
